import { OrderStatus } from '@/entities/api/orders/orders'

export const orderStatusMap = [
	{ name: 'Todas', value: '' },
	{ name: 'Nuevo', value: OrderStatus.new },
	{ name: 'Pendiente', value: OrderStatus.pending },
	{ name: 'En proceso', value: OrderStatus.processing },
	{ name: 'En camino', value: OrderStatus.on_the_way },
	{ name: 'Rechazado', value: OrderStatus.rejected },
	{ name: 'Entregado', value: OrderStatus.delivered },
	{ name: 'Reembolsado', value: OrderStatus.refunded },
]
